import { BenchmarkTypes } from 'types/Benchmark';

export const BenchmarkNameMaxLength = 75;

export const GetTimeZone = () => {
  return new Date()
    .toLocaleTimeString('en-us', { timeZoneName: 'short' })
    .split(' ')[2];
};

export const GetBenchmarkNameById = (typeId?: number) => {
  switch (typeId) {
    case BenchmarkTypes.AbsoluteReturn:
      return 'Absolute Return';
    case BenchmarkTypes.AssetWeighted:
      return 'Asset Weighted';
    case BenchmarkTypes.CompositeReturn:
      return 'Composite Return';
    case BenchmarkTypes.CompositeWeighted:
      return 'Composite Weighted';
    case BenchmarkTypes.PullForward:
      return 'Pull Forward';
    case BenchmarkTypes.StaticWeighted:
      return 'Static Weighted';
    default:
      return '';
  }
};
